import { render, staticRenderFns } from "./ComponentesForm.vue?vue&type=template&id=b8292cba&scoped=true&"
import script from "./ComponentesForm.vue?vue&type=script&lang=js&"
export * from "./ComponentesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8292cba",
  null
  
)

export default component.exports